var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('PageContainer',{attrs:{"size":"s"}},[_c('div',[(_vm.loading)?_c('p',[_vm._v(" Authentification en cours... ")]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }